import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Flex, Button, Text, SimpleGrid, Alert, AlertIcon } from '@chakra-ui/react';
import InputSearch from '../../../shared/inputSearch/InputSearch';
import Pagination from '../../../shared/pagination/Pagination';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import ShopItemsTable from './ShopItemsTable';
import CreateModal from './actions/CreateModal';
import UpdateModal from './actions/UpdateModal';
import DeleteModal from './actions/DeleteModal';
import { getShopItems, approveShopItem, rejectShopItem } from '../../../../store/shopItems/shopItemsSlice';
import { RulesWrapper } from '../rules/RulesStyle';
import theme from '../../../global/theme';

const ShopItems = () => {
  const dispatch = useDispatch();
  const shopItems = useSelector(state => state.shopItems);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState('');
  const [filter] = useState(JSON.stringify({}));
  const [showCreate, setShowCreate] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => { dispatch(getShopItems({ page, query, filter })); }, [dispatch, page, query, filter]);

  return (
    <RulesWrapper>
      <Breadcrumbs currentPage="متجر البيع والشراء" pages={[{ name: 'لوحة التحكم', path: '/admin' }]} />
      {shopItems.errors.length > 0 && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          {shopItems.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
        </Alert>
      )}
      <SimpleGrid columns={{ sm: 1, md: 2 }} justifyContent="space-between">
        <Flex marginBottom={8}>
          <Button bg="red.600" fontWeight="bold" fontSize={18} marginInlineEnd={4} color="white"
            _hover={{ bg: 'red.600' }} onClick={() => setShowCreate(true)}>
            إضافة إعلان
          </Button>
        </Flex>
        <Flex marginBottom={8} justifyContent="flex-end">
          <InputSearch isLoading={shopItems.isLoading} handleSearch={(q) => setQuery(q)} />
        </Flex>
      </SimpleGrid>
      {shopItems.data?.itemsCount > 0 ? (
        <ShopItemsTable data={shopItems.data.data} page={page}
          handleUpdate={(el) => setShowUpdate(el)} handleDelete={(el) => setShowDelete(el)}
          handleApprove={(el) => dispatch(approveShopItem({ _id: el._id }))}
          handleReject={(el) => dispatch(rejectShopItem({ _id: el._id }))} />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200}
          alignItems="center" justifyContent="center" borderRadius={4}>
          <Text fontSize={18} color="gray.300" fontWeight="bold">لا توجد إعلانات</Text>
        </Flex>
      )}
      <Flex justifyContent="flex-end">
        <Pagination page={page} itemsCount={shopItems.data?.itemsCount ?? 0} onChange={setPage} />
      </Flex>
      {showCreate && <CreateModal onClose={() => setShowCreate(false)} />}
      {showUpdate && <UpdateModal data={showUpdate} onClose={() => setShowUpdate(false)} />}
      {showDelete && <DeleteModal data={showDelete} onClose={() => setShowDelete(false)} />}
    </RulesWrapper>
  );
};

export default ShopItems;
